import Vue from 'vue'
import Router from 'vue-router'
import Authentication from '../components/Authentication/Authentication.vue'
import Dashboard from '../components/Dashboard/Dashboard.vue'
import Loyalty from '../components/Loyalty/Loyalty.vue'
import EditCard from '../components/Loyalty/EditCard.vue'
import ManageCard from '../components/Loyalty/ManageCard.vue'
import CustomerView from '../components/Customers/CustomerView.vue'
import GivePoints from '../components/Customers/GivePoints.vue'
import ManageRewards from '../components/Customers/ManageRewards.vue'
import Settings from '../components/Settings/Settings.vue'
import Staff from '../components/Staff/Staff.vue'
import Registration from '../components/Authentication/Registration.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Authentication',
      component: Authentication,
      meta: {
        title: 'Login - YesLoyal',
      }
    },
    {
      path: '/registration',
      name: 'Registration',
      component: Registration,
      meta: {
        title: 'Registration - YesLoyal',
      }
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard - YesLoyal',
      }
    },
    {
      path: '/loyalty',
      name: 'Loyalty',
      component: Loyalty,
      meta: {
        title: 'Loyalty program - YesLoyal',
      }
    },
    {
      path: '/loyalty/edit',
      name: 'EditCard',
      component: EditCard,
      meta: {
        title: 'Manage Loyalty Program - YesLoyal',
      }
    },
    {
      path: '/loyalty/manage',
      name: 'ManageCard',
      component: ManageCard,
      meta: {
        title: 'Manage Loyalty Program - YesLoyal',
      }
    },
    {
      path: '/customers',
      name: 'Customers',
      component: CustomerView,
      meta: {
        title: 'Manage Loyalty Program - YesLoyal',
      }
    },
    {
      path: '/customers/points/:user_id',
      name: 'GivePoints',
      component: GivePoints,
      meta: {
        title: 'Manage Loyalty Program - YesLoyal',
      }
    },
    {
      path: '/customers/manage/:user_id',
      name: 'ManageRewards',
      component: ManageRewards,
      meta: {
        title: 'Manage Rewards - YesLoyal',
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        title: 'Settings - YesLoyal',
      }
    },
    {
      path: '/staff',
      name: 'Staff',
      component: Staff,
      meta: {
        title: 'Staff - YesLoyal',
      }
    },
  ],
})

const openRoutes = ['Authentication', 'Registration']

function updatePageTitle (to, from, next) {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  })
  // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
}

router.beforeEach((to, from, next) => {
  if (openRoutes.includes(to.name)) {
    if (!localStorage.getItem('token')) {
      next()
    } else {
      next('/')
    }
  } else if (localStorage.getItem('token')) {
    next()
  } else {
    next('/login')
  }
})

router.beforeEach(updatePageTitle)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js